module.exports = __webpack_public_path__ + "img/338.e90313c3.jpg";